<script lang="ts">
    import time from "../../stores/time";
</script>

<span id="seconds" class="font-semibold clock-component">{ $time.format('ss') }</span>